<template>
  <form novalidate @submit.prevent="sendInvite">
    <LsModal title="Invite via Email" track-id="email_modal">
      <template #body>
        <div class="columns email-modal--body">
          <div class="column">
            <div v-for="(email, idx) in emails" :key="idx">
              <LsInput
                v-model="emails[idx]"
                :validation="{ required: idx === 0, email: true }"
                placeholder="Enter an email address"
                class="email-modal--input"
                :name="`email-${idx}`"
                track-id="email_modal-email"
                type="email"
              />
            </div>
            <LsButton
              type="button"
              text="ADD ANOTHER EMAIL ADDRESS"
              icon="add"
              bg-color="white"
              text-color="primary"
              track-id="email_modal-add_another_email"
              @click="addAdditonalInput"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <LsButton
          type="submit"
          text="SEND INVITE"
          track-id="email_modal-send_invite"
          :loading="share.loadingStatus.isUpdating"
        />
      </template>
    </LsModal>
  </form>
</template>

<script>
import { LsModal, LsButton, LsInput } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { SHARE__SHARE_VIA_EMAIL } from '@/store/types';

export default {
  name: 'EmailModal',
  components: {
    LsModal,
    LsButton,
    LsInput,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      emails: [''],
    };
  },
  computed: {
    ...mapState(['share']),
  },
  methods: {
    ...mapActions([SHARE__SHARE_VIA_EMAIL]),
    addAdditonalInput() {
      this.emails.push('');
    },
    async sendInvite() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      this[SHARE__SHARE_VIA_EMAIL]({
        emails: this.emails,
        onSuccess: this.$parent.close,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.email-modal--input {
  margin-bottom: 10px;
}
</style>
